export class APIError{
    code!: string;
    message!: string;
    status!: string;
    traceId!: string;
}